// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import "./OrderSuccess.css";

export default function OrderSuccess() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [orderDetails, setOrderDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const orderId = searchParams.get('orderId');
        const paymentId = searchParams.get('paymentId');

        if (orderId && paymentId) {
            // You can fetch order details from backend here if needed
            setOrderDetails({
                orderId: orderId,
                paymentId: paymentId,
                status: 'confirmed',
                timestamp: new Date().toLocaleString()
            });
        }
        setLoading(false);
    }, [searchParams]);

    if (loading) {
        return <div className="order-success-loading flex min-h-screen items-center justify-center bg-[linear-gradient(135deg,#667eea_0%,#764ba2_100%)] text-[1.2rem] text-white">Loading...</div>;
    }

    if (!orderDetails) {
        return (
            <div className="order-success-container flex min-h-screen items-center justify-center bg-[linear-gradient(135deg,#667eea_0%,#764ba2_100%)] p-[20px]">
                <div className="order-success-content w-full max-w-[600px] rounded-[20px] bg-white p-[40px] text-center shadow-[0_20px_40px_rgba(0,0,0,0.1)] max-[480px]:p-[20px_15px] min-[481px]:max-[767px]:m-[10px] min-[481px]:max-[767px]:p-[30px_20px]">
                    <div className="success-icon mb-[20px] text-[80px] max-[480px]:text-[60px]">❌</div>
                    <h1>Order Not Found</h1>
                    <p className="mb-[30px] text-[1.1rem] leading-[1.6] text-[#7f8c8d]">We couldn't find your order details. Please contact support if you believe this is an error.</p>
                    <button onClick={() => navigate('/store')} className="continue-shopping-btn inline-block rounded-[10px] border-none bg-[linear-gradient(135deg,#667eea_0%,#764ba2_100%)] px-[30px] py-[15px] text-[1rem] font-[600] text-white no-underline transition-all duration-300 hover:-translate-y-[2px] hover:shadow-[0_10px_20px_rgba(102,126,234,0.3)] max-[480px]:w-full min-[481px]:max-[767px]:w-full">
                        Continue Shopping
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="order-success-container flex min-h-screen items-center justify-center bg-[linear-gradient(135deg,#667eea_0%,#764ba2_100%)] p-[20px]">
            <div className="order-success-content w-full max-w-[600px] rounded-[20px] bg-white p-[40px] text-center shadow-[0_20px_40px_rgba(0,0,0,0.1)] max-[480px]:p-[20px_15px] min-[481px]:max-[767px]:m-[10px] min-[481px]:max-[767px]:p-[30px_20px]">
                <div className="success-icon mb-[20px] text-[80px] max-[480px]:text-[60px]">✅</div>
                <h1>Order Confirmed!</h1>
                <p className="mb-[30px] text-[1.1rem] leading-[1.6] text-[#7f8c8d]">Thank you for your purchase. Your order has been successfully placed.</p>
                
                <div className="order-details mb-[30px] rounded-[15px] bg-[#f8f9fa] p-[25px] text-left">
                    <h2>Order Details</h2>
                    <div className="detail-row flex items-center justify-between border-b border-[#e9ecef] py-[12px] max-[767px]:flex-col max-[767px]:items-start max-[767px]:gap-[5px]">
                        <span className="label font-[600] text-[#495057]">Order ID:</span>
                        <span className="value font-['Courier_New',monospace] font-[500] text-[#6c757d]">{orderDetails.orderId}</span>
                    </div>
                    <div className="detail-row flex items-center justify-between border-b border-[#e9ecef] py-[12px] max-[767px]:flex-col max-[767px]:items-start max-[767px]:gap-[5px]">
                        <span className="label font-[600] text-[#495057]">Payment ID:</span>
                        <span className="value font-['Courier_New',monospace] font-[500] text-[#6c757d]">{orderDetails.paymentId}</span>
                    </div>
                    <div className="detail-row flex items-center justify-between border-b border-[#e9ecef] py-[12px] max-[767px]:flex-col max-[767px]:items-start max-[767px]:gap-[5px]">
                        <span className="label font-[600] text-[#495057]">Status:</span>
                        <span className="value status-confirmed font-['Courier_New',monospace] font-[600] text-[#28a745]">{orderDetails.status}</span>
                    </div>
                    <div className="detail-row flex items-center justify-between py-[12px] max-[767px]:flex-col max-[767px]:items-start max-[767px]:gap-[5px]">
                        <span className="label font-[600] text-[#495057]">Date:</span>
                        <span className="value font-['Courier_New',monospace] font-[500] text-[#6c757d]">{orderDetails.timestamp}</span>
                    </div>
                </div>

                <div className="next-steps mb-[30px] rounded-[15px] bg-[#e8f5e8] p-[25px] text-left">
                    <h3>What's Next?</h3>
                    <ul className="m-0 list-none p-0">
                        <li className="next-step-item relative py-[8px] pl-[25px] text-[#495057]">You'll receive an order confirmation email shortly</li>
                        <li className="next-step-item relative py-[8px] pl-[25px] text-[#495057]">We'll notify you when your order ships</li>
                        <li className="next-step-item relative py-[8px] pl-[25px] text-[#495057]">View your order details in the Order History section</li>
                    </ul>
                </div>

                <div className="action-buttons flex flex-wrap justify-center gap-[15px] max-[767px]:flex-col">
                    <button onClick={() => navigate('/order-history')} className="order-history-btn inline-block rounded-[10px] border-none bg-[#28a745] px-[30px] py-[15px] text-[1rem] font-[600] text-white no-underline transition-all duration-300 hover:-translate-y-[2px] hover:bg-[#218838] hover:shadow-[0_10px_20px_rgba(40,167,69,0.3)] max-[767px]:w-full">
                        View Order History
                    </button>
                    <button onClick={() => navigate('/store')} className="continue-shopping-btn inline-block rounded-[10px] border-none bg-[linear-gradient(135deg,#667eea_0%,#764ba2_100%)] px-[30px] py-[15px] text-[1rem] font-[600] text-white no-underline transition-all duration-300 hover:-translate-y-[2px] hover:shadow-[0_10px_20px_rgba(102,126,234,0.3)] max-[767px]:w-full">
                        Continue Shopping
                    </button>
                    <button onClick={() => navigate('/')} className="home-btn inline-block rounded-[10px] border-none bg-[#6c757d] px-[30px] py-[15px] text-[1rem] font-[600] text-white no-underline transition-all duration-300 hover:-translate-y-[2px] hover:bg-[#5a6268] hover:shadow-[0_10px_20px_rgba(108,117,125,0.3)] max-[767px]:w-full">
                        Go to Home
                    </button>
                </div>
            </div>
        </div>
    );
}




